
<div class="bradcam_area bradcam_bg_2">
    <div class="container">
        <div class="row">
            <div class="col-xl-12">
                <div class="bradcam_text">
                    <h3 i18n>Transaction</h3>
                </div>
            </div>
        </div>
    </div>
</div>
<div >
      <br>
      <br>
      <br>
      <div class="section" >
          <!-- container -->
          <div class="container">
            <!-- row -->
            <div class="row">
          
              <div class="col-md-7">
                <!-- Billing Details -->
                <div class="billing-details">
                  <div class="section-title">
                    <h3 class="title" i18n>Recipient</h3>
                  </div>
              
                </div>
                <!-- /Billing Details -->
          
                <!-- Shiping Details -->
                <div class="shiping-details row">

                    <div class="col-sm">
                        <ng-multiselect-dropdown
                            [placeholder]="'Select the recipient'"
                            [settings]="dropdownSettings"
                            [data]="dropdownList"
                            [(ngModel)]="selectedItems"
                            (onSelect)="onItemSelect($event)"
                            (onSelectAll)="onSelectAll($event)"
                            (onDeSelect)="onItemDeSelect($event)"
                            >
                        </ng-multiselect-dropdown>
                      </div>
                      <div class="col-sm d-none d-sm-block">
                          <a class="boxed-btn4-xs bg-success text-light" >
                              <span class="glyphicon glyphicon-plus-sign" (click)="openModal(template1)"></span> 
                          </a>
                      </div>
                    <!-- <div id="particles-js"></div> -->

                </div>
                <!-- /Shiping Details -->

               
                <div *ngIf="!enableError"> . </div>
                <div class="align-items-center justify-content-center" data-aos="fade-up" data-aos-duration="1500" *ngIf="enableError"  style="color: red;" i18n>
                  Beneficiary required !
                </div>

                <div class="d-block d-sm-none text-center">
                  <a class="boxed-btn4-xs bg-success text-light"  >
                      <span class="glyphicon glyphicon-plus-sign" (click)="openModal(template1)"></span> 
                  </a>
                  <br>
                  <br>
                  <br>
              </div> 
          
              </div>

              
            
              <!-- Order Details -->
              <div class="col-md-5 order-details">
                <div class="section-title text-center">
                  <h3 class="title" i18n>Your Transaction</h3>
                </div>
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th scope="col" i18n>Description</th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                          <td i18n>To :</td>
                          <td>{{countryToSend}}</td>
                      </tr>
                    <tr>
                      <td i18n>From :</td>
                      <td>{{countryToReceive}}</td>
                    </tr>
                    <tr>
                      <td i18n>Amount to send : </td>
                      <td><strong>{{sendValue}} </strong></td>
                    </tr>
                    <tr>
                      <td i18n>Amount to be received :</td>
                      <td><strong>{{receiveValue}} </strong></td>
                    </tr>
                    <tr>
                      <td i18n>Transaction fees :</td>
                      <td><strong>0 $CA</strong></td>
                    </tr>
                    <tr>
                      <td i18n>Receive mode :</td>
                      <td>Mobile money</td>
                    </tr>
                    <tr>
                      <td i18n>Payment method :</td>
                      <td i18n>Interact transfer</td>
                    </tr>
                    <tr>
                      <td i18n>Change rate :</td>
                      <td><strong>{{currentRate}}</strong></td>
                    </tr>
                  </tbody>
                </table>
                <!-- <button type="submit" class="btn-outline-danger btn-sm my-2 btn-block hoverClass" style="border-color: black; background-color: aqua;">Confirmer</button> -->
                <div class="row d-flex justify-content-center">
                  <button class="boxed-btn3-xl d-none d-sm-block" (click)="confirmTransaction()" type="submit" i18n>Confirm</button>
                  <button class="boxed-btn3-xs d-block d-sm-none" (click)="confirmTransaction()" type="submit" i18n>Confirm</button>
                </div>
                <br>
                
              </div>
              <!-- /Order Details -->
            </div>
            <!-- /row -->
          </div>
          <!-- /container -->
          </div>
          <br>
          <br>
          <br>

  </div>


   <!-- Ajouter beneficiare -->
<ng-template #template1>
    
  <div class="modal-header" style="background-color: #FFD700;">   
    <h4 class="modal-title pull-left" style="font-size: 10px !important;" i18n>Edit</h4>
    <button type="button" class="close pull-rigth" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <form>
      <div data-aos="fade-right" data-aos-duration="1500"><label for="exampleInputPrenom1" i18n>Identification</label></div>
      <div class="row form-group">
        <div class="col">
          <input type="text" class="form-control" #Inputprenom placeholder="First name">
          <div *ngIf="enablePrenom" style="color: red;" i18n>First name required please !</div>
        </div>
        <div class="col"> 
          <input type="text" class="form-control" #Inputnom placeholder="Name">
          <div *ngIf="enableNom"  style="color: red;" i18n>Name required please !</div>
        </div>
      </div>
    <div class="row form-group">
      <div class="col">
        <input type="text" class="form-control" #InputCountry placeholder="Country">
        <div  *ngIf="enableCountry"  style="color: red;" i18n>Country required please !</div>
      </div>
      <div class="col">
        <input type="text" class="form-control" #InputTown placeholder="City">
        <div  *ngIf="enableTown"  style="color: red;" i18n>City required please !</div>
      </div>
      <div class="col">
        <input type="text" class="form-control" #InputProvince placeholder="Province">
      </div>
    </div>
    <div class="form-group">
      <div data-aos="fade-right" data-aos-duration="1500"><label for="exampleInputPrenom1" i18n>Phone</label></div>
     
      <div class="row">
        <div class="col">

            <select name="selectId" class="form-control" id="selectId" (change)="selectElement($event)">
              <option value="0" label="Select a country ... " selected="selected">Select a country ... </option>
              <optgroup id="country-optgroup-Africa" label="Africa">
                  <option value="CM" label="Cameroon"> Cameroon</option>
                  <option value="CI" label="Côte d’Ivoire">Côte d’Ivoire</option>
              </optgroup>
              <optgroup id="country-optgroup-Americas" label="Americas">
                  <option value="CA" label="Canada">Canada</option>
                  <option value="US">United States</option>
              </optgroup>
              <optgroup id="country-optgroup-Asia" label="Asia">
                  <option value="CN" label="China">China</option>
              </optgroup>
              <optgroup id="country-optgroup-Europe" label="Europe">    
                  <option value="FR" label="France">France</option>
                  <option value="GB" label="United Kingdom">United Kingdom</option>
              </optgroup>
            </select>

        </div>
        <div class="col">
          <input type="tel" id="InputTel" class="form-control inputSize" #InputTel placeholder="Phone">
        </div>
      </div>

      <div  *ngIf="enableTelephone"  style="color: red;" i18n>Phone-- required please !</div>
    </div> 
    <div class="form-group">
        <div data-aos="fade-right" data-aos-duration="1500"><label for="exampleInputEmail1" i18n>Email address</label></div>
        <input type="email" class="form-control" id="exampleInputEmail1" #Inputemail aria-describedby="emailHelp" placeholder="Enter email" required>
        <div  *ngIf="enableEmail"  style="color: red;" i18n>Email required please !</div>
    </div>    
    </form>
  </div>

  <div class="modal-footer">
  <button type="submit" class="boxed-btn4-xs h-15"  (click)="ajouter(Inputnom,Inputprenom,InputCountry,InputProvince,InputTown,Inputemail,InputTel)" i18n>Create</button>
  <button type="button" class="boxed-btn4-red-xs pull-rigth" (click)="modalRef.hide()" i18n>Close</button>
  
  </div>

</ng-template>
<!-- / Ajouter beneficiare  -->

